import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { decode } from "html-entities";
import { useTranslation } from "react-i18next";
// @ts-ignore
import { useTheme } from "@mui/material/styles";
// helpers
import { getOfferNameForBreadcrumb } from "./helpers/getOfferNameForBreadcrumb";
import { getBreadcrumbs } from "./helpers/getBreadcrumbs";
import { getAirportBusSlugFromPathname } from "../../pages/PublicTransport/AirportBus/helpers/buildAirportBusBreadcrumbEntries";
import { getAirportBusProviderBySlug } from "../../pages/PublicTransport/AirportBus/providers";
// types
import { CrumbsType } from "./types";

export default function AppBreadcrumbs() {
  const theme = useTheme();
  const location = useLocation();
  const { t } = useTranslation();

  // states
  const tenantInfo = useSelector((state: any) => state.tenant.tenantInfo);
  const offer = useSelector((state: any) => state.offerDetails.offer);
  const bookingStatus = useSelector((state: any) => state.confirmation.bookingStatus);
  const searchedQuery = useSelector((state: any) => state.explore.searchedQuery);
  const categories = useSelector((state: any) => state.explore.categories);
  const airportBusProvider = useSelector((state: any) => state.airportBus?.providerData);

  // @ts-ignore
  const bookingState = JSON.parse(sessionStorage.getItem("bookingState"));

  const breadcrumbsList = (): Array<CrumbsType> => {
    const offerName: string = getOfferNameForBreadcrumb(
      offer?.title || bookingState?.state?.offer?.title,
      location?.state?.offer?.title,
      bookingStatus?.event_name
    );

    const airportBusSlug = getAirportBusSlugFromPathname(location?.pathname || "");
    const airportBusConfig = airportBusSlug ? getAirportBusProviderBySlug(airportBusSlug) : undefined;
    const airportBusOfferName: string | undefined = airportBusConfig
      ? airportBusProvider?.provider_title || airportBusProvider?.title || airportBusConfig.fallbackDisplayName
      : undefined;

    return getBreadcrumbs(
      location,
      tenantInfo?.name,
      offerName,
      searchedQuery,
      categories,
      t("breadcrumbs.searchResult"),
      t("breadcrumbs.categoryResult"),
      t("breadcrumbs.checkout"),
      t("breadcrumbs.confirmation"),
      airportBusOfferName
    );
  };

  return (
    <Grid container sx={{ maxWidth: "1400px", margin: "0 auto" }} pt={1} pl={{ xs: 4.5 }}>
      <Breadcrumbs separator=":" aria-label="breadcrumb">
        {breadcrumbsList()?.map((crumb: CrumbsType, index: number) => {
          const isLastCrumb = breadcrumbsList()?.length - 1 === index;
          return (
            <Link
              data-cy={decode(crumb?.name)}
              key={crumb.href}
              underline="hover"
              href={crumb.href}
              sx={{
                color: theme.palette.primary.dark,
                fontSize: "15px",
                pointerEvents: isLastCrumb ? "none" : "auto"
              }}
            >
              {decode(crumb?.name)}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Grid>
  );
}
